import type { AppLocale } from "./index"
import { EXTENDED_ADMIN_UI } from "./extendedLocaleUi"
import { isExtendedLocale } from "./isExtendedLocale"
import { adminUi as legacyAdminUi, type AdminUiKey } from "./legacy/adminUi"
import type { AppLocale as LegacyAppLocale } from "./legacy/index"
import { PUBLIC_EXTRA_ADMIN_UI } from "./publicExtraBasicUi"
import { isPublicExtraLocale } from "./publicExtraSignals"
import { uzbekLatinToCyrillic } from "./uzbekCyrillic"
import { isExpansionLocale } from "./publicExpansionSignals"
import { EXPANSION_ADMIN_UI } from "./publicExpansionBasicUi"

export type { AdminUiKey } from "./legacy/adminUi"

export function adminUi(locale: AppLocale, key: AdminUiKey): string {
  if (isExpansionLocale(locale)) return EXPANSION_ADMIN_UI[locale][key]
  if (isPublicExtraLocale(locale)) {
    return PUBLIC_EXTRA_ADMIN_UI[locale][key]
  }
  if (isExtendedLocale(locale)) {
    return (EXTENDED_ADMIN_UI[locale] as Record<AdminUiKey, string>)[key]
  }
  const value = legacyAdminUi(locale as LegacyAppLocale, key)
  return locale === "uz" ? uzbekLatinToCyrillic(value) : value
}
